import { capture } from '../../services/sentry/capture';
import AxiosError from '../../helpers/errors/axios.error';
import { unloggedStrapiAxios } from '../strapiAxios';
import { ProfParamsForInscriptionOnStrapi } from '../../types/user/prof.def';

const registerProf = async (values: ProfParamsForInscriptionOnStrapi) => {
  try {
    return await unloggedStrapiAxios.post('/auth/local/register', values);
  } catch (e) {
    const axiosErr = new AxiosError('Inscription prof', e);
    capture(axiosErr, [
      { key: 'details', extra: axiosErr },
      { key: 'message original', extra: e.message },
      { key: 'values', extra: values }
    ]);
    throw axiosErr;
  }
};
export default registerProf;
